export default function Loading() {
  return (
    <div className="fixed inset-0 bg-[rgba(0, 0, 0, 0.80)] z-[10000] flex flex-1 items-center justify-center">
      <span className="loader"></span>
    </div>
  );
}
